import React from 'react';
import { moneyFormatter, FormatRule } from '@utex/ui-kit';
import { useTranslation } from 'react-i18next';

export interface Money {
  value: number;
  currency: string;
}

export interface MoneyV2 {
  value: string | number;
  currency: { code: string };
}

interface Props {
  children: Money | MoneyV2 | null | undefined;
  rule?: FormatRule;
}

export const MoneyView: React.FC<Props> = ({ children: money, rule }) => {
  const {
    i18n: { language },
  } = useTranslation();

  if (!money) {
    return null;
  }

  const result = moneyFormatter({
    money: {
      value: +money.value,
      currency: typeof money.currency === 'object' ? money.currency.code : money.currency,
    },
    rule: rule || '0-2',
    locale: language,
  }).formatted;

  return <>{result}</>;
};
